import {
  type KeyboardAvoidingViewProps,
  Platform,
  KeyboardAvoidingView as RNKeyboardAvoidingView,
} from "react-native";

/**
 * 🚨 Ensure that the KeyboardAvoidingView has a fixed height to avoid onLayout cycles
 */
export const KeyboardAvoidingView = (
  keyboardAvoidingViewProps: KeyboardAvoidingViewProps,
) => {
  return (
    <RNKeyboardAvoidingView
      behavior={Platform.select({ ios: "padding" })}
      {...keyboardAvoidingViewProps}
    />
  );
};
